export const formatStatus = (status?: string) => {
  const words = (status ?? '').toLowerCase().split('_').filter(Boolean).join(' ');
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : '—';
};
